import React, { useState } from "react";
import { NavLink } from "react-router-dom";

export default function NavLinkButton({
  text,
  to,
  backgroundColor,
  backgroundColorHover,
  color,
  colorHover,
  borderColor,
  borderColorHover,
  shadow = false,
  px,
}) {
  const [currentBackgroundColor, setCurrentBackgroundColor] =
    useState(backgroundColor);
  const [currentColor, setCurrentColor] = useState(color);
  const [currentBorderColor, setCurrentBorderColor] = useState(borderColor);

  const onHover = () => {
    setCurrentBackgroundColor(backgroundColorHover);
    setCurrentColor(colorHover);
    setCurrentBorderColor(borderColorHover);
  };

  const onUnhover = () => {
    setCurrentBackgroundColor(backgroundColor);
    setCurrentColor(color);
    setCurrentBorderColor(borderColor);
  };

  return (
    <NavLink to={to} style={{ textDecoration: "none" }}>
      {({ isActive }) => (
        <div
          className={`rounded-md text-center ${shadow ? "shadow-sm" : ""} ${px ? "px-3" : "px-0"
            }`}
          style={{
            background: isActive
              ? backgroundColorHover
              : currentBackgroundColor,
            color: isActive ? colorHover : currentColor,
            paddingTop: "0.45rem",
            paddingBottom: "0.45rem",
          }}
          onMouseEnter={onHover}
          onMouseLeave={onUnhover}
        >
          {text}
        </div>
      )}
    </NavLink>
  );
}
